/**
 * The shared tag list, `base@1` (PE v3.5 delivery note, Oct 26): concrete
 * things a photo can show, offered in the Media Library's tag box so hand
 * tagging uses the same words PE's photo selection does. Free text is still
 * allowed. PE's copy is `BASE_VOCABULARY` in its api/tag_suggest.py and
 * `GET /v3/tags/base_vocabulary`; any change to this list is `base@2` there.
 *
 * Status: PE's draft, pending David's confirmation.
 */
export const BASE_VOCABULARY_VERSION = "base@1";

export const BASE_VOCABULARY = {
  activity: ["music", "dancing", "sports", "swimming", "hiking", "gardening", "cooking",
             "art", "crafts", "reading", "games", "exercise", "shopping"],
  place:    ["beach", "park", "garden", "mountains", "lake", "restaurant", "church", "outdoors"],
  occasion: ["birthday", "party", "holiday", "wedding", "graduation", "meal"],
  animal:   ["dog", "cat", "horse", "bird"],
  object:   ["car", "boat", "bicycle", "flowers", "snow"],
};

export const BASE_TAGS = [...new Set(Object.values(BASE_VOCABULARY).flat())];
